exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3 {\n  color: #000447;\n  margin: 0 0 30px;\n  padding-bottom: 20px;\n  border-bottom: 1px dashed #000447; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/app/humanresources/humanresources.component.scss
// module id = ../../../../../src/app/humanresources/humanresources.component.scss
// module chunks = main